import React, { useState, useEffect } from 'react';
import { Layout, Breadcrumb } from 'antd';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import NewFieldModal from './NewFieldModal';
import ContentModelFields from './ContentModelFields';
import InnerHeader from '../../component/InnerHeader';
import { fetchCustomTypeById, setCustomTypeDraft } from '../../actions/CustomTypeAction';
import Loader from '../../component/Loader/Loader';
import { getContentById, updateContent, updateCustomType } from '../../services/napi';

import ArrowNextIcon from '../../asset/arrow-next.svg';

const ContentModelDetail = () => {
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const [isSaveEnabled, setSaveEnabled] = useState(true);
  const { contentModelId } = useParams();
  const [deletedFieldInfo, setDeletedFieldInfo] = useState([]);

  const toggleModal = () => {
    setModalVisible((prevState) => !prevState);
  };

  function itemRender(route, params, routes, paths) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <Link to={paths.join('/')}>{route.breadcrumbName}</Link>
    );
  }

  const onModalOk = ({ type, apiId, name, props }) => {
    dispatch(
      setCustomTypeDraft({
        ...customTypeDraft,
        template: {
          ...customTypeDraft.template,
          [apiId]: {
            field_addition: { ...props },
            field_name: apiId,
            field_type: type,
            label: name
          }
        }
      })
    );
    toggleModal();
  };

  // eslint-disable-next-line no-unused-vars
  async function deleteFieldFromContent(customTypeDraft) {
    const currentProjectId = customTypeDraft.project;
    const contentIds = customTypeDraft.content || [];
    const { languages } = customTypeDraft;

    if (contentIds.length !== 0) {
      await Promise.all(
        contentIds.map(async (id) => {
          const response = await getContentById(id, currentProjectId);
          const { content } = response.data;
          const { data } = content;

          languages.forEach((language) => {
            const specificLanguageData = data[language];

            deletedFieldInfo.forEach((obj) => {
              const { fieldName, fieldType, removeType, key } = obj;

              if (removeType === 'field') {
                delete specificLanguageData[fieldName];
              } else if (removeType === 'field key' && fieldType === 'complex list') {
                delete specificLanguageData[fieldName][key];
              }
            });
          });

          await updateContent(content, content._id, content.project);
        })
      );
    }

    setDeletedFieldInfo([]);
  }

  const onSave = async () => {
    setSaveEnabled(false);
    await updateCustomType(customTypeDraft, customTypeDraft._id, customTypeDraft.project);
    // if (deletedFieldInfo.length !== 0) {
    //   await deleteFieldFromContent(customTypeDraft);
    // }
    setSaveEnabled(true);
    onBack();
  };

  const actions = [
    {
      onClick: toggleModal,
      title: 'Add New Field',
      type: 'primary'
    },
    {
      disabled: !isSaveEnabled,
      onClick: onSave,
      title: 'Save',
      type: 'primary'
    }
  ];

  const onBack = () => {
    window.history.back();
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchCustomTypeById(contentModelId, true));
    }

    load();
  }, [contentModelId, dispatch]);

  const customTypeDraft = useSelector(({ customType }) => customType.customTypeDraft);

  if (!Object.keys(customTypeDraft).length) {
    return <Loader />;
  }

  const routes = [
    {
      breadcrumbName: 'home',
      path: '/'
    },
    {
      breadcrumbName: customTypeDraft.name,
      path: 'content-model'
    }
  ];

  const onSwitch = (isEnabled) => {
    dispatch(
      setCustomTypeDraft({
        ...customTypeDraft,
        isHighlighted: isEnabled
      })
    );
  };

  const handleCallBack = (data) => {
    const newCustomTypeDraft = customTypeDraft;
    if (data) {
      newCustomTypeDraft.name = data;
      dispatch(setCustomTypeDraft(newCustomTypeDraft));
    }
  };

  return (
    <Layout>
      <Breadcrumb
        itemRender={itemRender}
        routes={routes}
        separator={<img alt="separator icon" src={ArrowNextIcon} />}
        style={{
          background: 'white',
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '40px 0px 34px 35px'
        }}
      />
      <InnerHeader
        actions={actions}
        copyId={customTypeDraft.api_id}
        isHighlightEnabled={customTypeDraft.isHighlighted}
        onBack={onBack}
        onSwitch={onSwitch}
        parentCallBack={handleCallBack}
        subtitle=""
        title={customTypeDraft.name}
      />
      <NewFieldModal onCancel={toggleModal} onOk={onModalOk} visible={modalVisible} />
      <ContentModelFields
        setDeletedFieldInfo={setDeletedFieldInfo}
        template={customTypeDraft.template}
      />
    </Layout>
  );
};

export default ContentModelDetail;
